// extracted by mini-css-extract-plugin
export default {"dead-mans-handle-countdown":"DeadMansHandleContent_dead-mans-handle-countdown__odj0O"};